import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { RepairProvider } from "./context/RepairContext";
import { AuthProvider } from "./context/AuthContext";
import { RepairShopProvider } from "./context/RepairShopContext";
import { StockProvider } from "./context/StockContext";
import { ThemeProvider } from "./context/ThemeContext";
import { AnnouncementProvider } from "./context/AnnouncementContext";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import NewRepair from "./pages/NewRepair";
import RepairDetail from "./pages/RepairDetail";
import SearchPage from "./pages/SearchPage";

import NotFound from "./pages/NotFound";
import StockManagement from "./pages/StockManagement";
import Login from "./pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import AnnouncementManager from "./components/announcements/AnnouncementManager";
// Import i18n to ensure it's initialized
import "./i18n";

// Create a client
const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <ThemeProvider>
          <AuthProvider>
            <RepairShopProvider>
              <RepairProvider>
                <StockProvider>
                  <AnnouncementProvider>
                    <TooltipProvider>
                      <Routes>
                        <Route path="login" element={<Login />} />
                        <Route element={<ProtectedRoute />}>
                          <Route path="/" element={<Layout />}>
                            <Route index element={<Dashboard />} />
                            <Route path="new-repair" element={<NewRepair />} />
                            <Route
                              path="repair/:id"
                              element={<RepairDetail />}
                            />
                            <Route path="search" element={<SearchPage />} />
                            <Route path="stock" element={<StockManagement />} />

                            <Route path="*" element={<NotFound />} />
                          </Route>
                        </Route>
                      </Routes>
                      <AnnouncementManager />
                      <Toaster />
                      <Sonner />
                    </TooltipProvider>
                  </AnnouncementProvider>
                </StockProvider>
              </RepairProvider>
            </RepairShopProvider>
          </AuthProvider>
        </ThemeProvider>
      </HashRouter>
    </QueryClientProvider>
  );
};

export default App;
